/**
 * **Die oberste Zeile, die im Scroller gerade zu sehen ist** — `null`, wenn keine.
 *
 * Gebraucht wird sie an genau einer Stelle: Wer die **Aufgaben-Details** ohne
 * Auswahl öffnet, wählt damit die oberste SICHTBARE Zeile (CONTEXT.md,
 * Aufgaben-Details). Nicht die erste der Liste — wer weit unten steht und den
 * Knopf drückt, meint das, was dort liegt; die erste zu nehmen hieße, die Liste
 * unter der Hand nach oben zu reißen oder etwas zu zeigen, das gerade niemand
 * sieht.
 *
 * **Angeschnittene Zeilen zählen nicht**, oben wie unten: Wer die
 * Aufgaben-Details öffnet, meint die Aufgabe, die er GANZ vor sich hat. Die Zeilen stehen im DOM
 * in Sichtreihenfolge, also endet die Suche bei der ersten, die unten über die
 * Kante läuft — alle danach liegen noch tiefer.
 *
 * Misst der Kasten gar nichts, gibt es nichts zu sehen: Inaktive Tabs bleiben mit
 * `display: none` montiert (CLAUDE.md) und liefern lauter Nullen — daraus fiele
 * sonst zufällig die erste Zeile heraus.
 *
 * @example
 * const id = bodyMainRef.current ? topVisibleTaskId(bodyMainRef.current) : null
 */
export function topVisibleTaskId(container: HTMLElement): string | null {
  const box = container.getBoundingClientRect()
  if (box.height === 0) return null

  for (const el of container.querySelectorAll<HTMLElement>('[data-task-id]')) {
    const rect = el.getBoundingClientRect()
    // Oben herausgescrollt oder angeschnitten — weiter zur nächsten.
    if (rect.top < box.top) continue
    // Unten über die Kante: Ab hier liegt alles außerhalb.
    if (rect.bottom > box.bottom) break
    return el.dataset.taskId ?? null
  }

  return null
}
